<template>
    <div>
        <div>
            <data-table
                v-if="tableLoaded"
                :exportable = "false" title=""
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"
                @rowClickDelete="onDeleteRow"
                @rowClickEdit="onEditRow"
                @changePage="changePage"
                @searchEvent="searchEvent"
                @orderByEvent="orderByEvent"
                @rowClickCheck="onClickCheck"
                >
            </data-table>
            <b-btn class="btn btn-default mt-3" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_task_manager'], ['create']) && createBtn == true"><i class="fa fa-plus-circle mr-1"></i> {{$t('general.administrative.task_manager.create_task')}}</b-btn>
        </div>

        <task-modal 
            :title="actionTitle" 
            :model.sync="model" 
            @onLoadTable="onLoadTable" 
            ref="taskModal"
        />

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ deleteMessage }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';
import TaskModal from '@/components/global/modals/TaskModal.vue';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
    name: 'task_table',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
        flatPickr,
        TaskModal
    },
    props: {
        createBtn: {
            default: true,
        },
        closed: {
            default: null,
        },
        userId: {
            default: null,
        }
    },
    data() {
        return {
            tableNameTranslated: Vue.i18n.translate('general.administrative.task_manager.title_modal'),
            tableName: 'task_manager',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            deleteMessage: '',
            getData: {
                rowData: []
            },
            model: {
                id: null,
                task_no: null,
                task_title: null,
                by_user_id: null,
                to_company_id: null,
                to_user_id: null,
                to_team_id: null,
                discipline_id: null,
                latest_date: null,
                exact_date: null,
                exact_time: null,
                importancy: null,
                urgency: null,
                status: null,
                closed: false,
                selectedDiscipline: null,
                selectedToCompany: null,
                selectedUser: null,
                selectedToTeam: null,
            },
            columnData: [
                {
                    width: '90px',
                    label: Vue.i18n.translate('misc.actions'),
                    field: '',
                    showEditButton: true,
                    showDeleteButton: true
                },
                {
                    label: Vue.i18n.translate('table.task_no'),
                    field: 'task_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.task_title'),
                    field: 'task_title',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.from_user'),
                    field: 'by_user.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.to_company'),
                    field: 'to_company.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.to_user'),
                    field: 'to_user.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.to_team'),
                    field: 'to_team.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.discipline'),
                    field: 'discipline.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.drawing'),
                    field: 'drawing.info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.latest_date'),
                    width: '115px',
                    field: 'latest_date',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.exact_date'),
                    width: '105px',
                    field: 'exact_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.exact_time'),
                    field: 'exact_time',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.importancy'),
                    field: 'importancy',
                    numeric: false,
                    html: false
                },
                {
                    label: Vue.i18n.translate('table.urgency'),
                    field: 'urgency',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.status'),
                    field: 'statusV',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.closed'),
                    field: 'closed',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                }
            ]
        }
    },
    mounted () {
        this.onLoadTable();
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 6000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?project_id=' + this.$route.params.id + '&filters[by_user_id]=' + this.userId + '&filters[closed]=' + this.closed + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (field.by_user == null) {
                            field.by_user = { 'fullname': '' };
                        }

                        if (field.discipline_id == null) {
                            field.discipline = { 'name': '' };
                        }

                        if (field.drawing_id == null) {
                            field.drawing = { 'info': '' };
                        }

                        if (field.to_company_id == null) {
                            field.to_company = { 'name': '' };
                        }

                        if (field.to_user_id == null) {
                            field.to_user = { 'fullname': '' };
                        }

                        if (field.to_team_id == null) {
                            field.to_team = { 'name': '' };
                        }

                        if (typeof this.$refs.taskModal.statuses[field.status] != 'undefined') {
                            field.statusV = this.$refs.taskModal.statuses[field.status].name;
                        }
                    });

                    this.getData.rowData = data;
                    this.tableLoaded = true;
                    this.$emit('loadTable');
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.$refs.taskModal.hideOthers(null, true);
            this.model.loggedUser = this.$store.state.user.user.firstname + ' ' + this.$store.state.user.user.lastname;
            this.row = null;
            this.$refs.taskModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.model.id = row.id;
            this.model.loggedUser = this.row.by_user.fullname;
            var array = [this.row.to_company, this.row.to_user, this.row.to_team];
            array.forEach((value, key) => {
                if(Object.keys(value).length != 1) {
                    this.$refs.taskModal.hideOthers(key);
                }
            });

            this.model.task_no       = this.row.task_no;
            this.model.task_title    = this.row.task_title;
            this.model.by_user_id    = this.row.by_user_id;
            this.model.to_company_id = this.row.to_company_id;
            this.model.to_user_id    = this.row.to_user_id;
            this.model.to_team_id    = this.row.to_team_id;
            this.model.discipline_id = this.row.discipline_id;
            this.model.drawing_id    = this.row.drawing_id;
            this.model.latest_date   = this.row.latest_date;
            this.model.exact_date    = this.row.exact_date;
            this.model.exact_time    = this.row.exact_time;
            this.model.importancy    = this.row.importancy;
            this.model.urgency       = this.row.urgency;
            this.model.status        = this.row.status;
            this.model.closed        = Boolean(this.row.closed);

            this.model.selectedDiscipline = (this.row.discipline != null && typeof this.row.discipline.name != 'undefined' && this.row.discipline.name != '') ? this.row.discipline : null;
            this.model.selectedDrawing    = (this.row.drawing != null && typeof this.row.drawing.info != 'undefined' && this.row.drawing.info != '') ? this.row.drawing : null;
            this.model.selectedUser       = (this.row.to_user != null && typeof this.row.to_user.fullname != 'undefined' && this.row.to_user.fullname != '') ? this.row.to_user : null;
            this.model.selectedToCompany  = (this.row.to_company != null && typeof this.row.to_company.name != 'undefined' && this.row.to_company.name != '') ? this.row.to_company : null;
            this.model.selectedToTeam     = (this.row.to_team != null && typeof this.row.to_team.name != 'undefined' && this.row.to_team.name != '') ? this.row.to_team : null;

            this.$refs.taskModal.show();
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.deleteMessage = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onClickCheck (row, index, column) {
            if (row) {
                this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];

                let data = http.route(this.tableName + '/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        if (clone.closed == 1) {
                            this.infoMsg(this.tableNameTranslated + ' ' + Vue.i18n.translate('messages.is_closed'));
                        } else {
                            this.infoMsg(this.tableNameTranslated + ' ' + Vue.i18n.translate('messages.is_open'));
                        }
                    }
                });
                this.model[column.toString()] = null;
            }
        },
    }
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/project/administrative/task_manager/task_table.vue